module.exports = __webpack_public_path__ + "static/service2-50b67474250e387dd3c9961f4a7703b2.png";